<!--
  Decorator to the <b-spinner> "bootstrap-vue-next" component

  @link https://bootstrap-vue-next.github.io/bootstrap-vue-next/docs/components/spinner.html
-->
<template>
  <b-spinner
    v-bind="bSpinnerBind"
    :class="[
      'ui-spinner',
      `ui-spinner--${size}`,
      `ui-spinner--${type}`,
      {
        'ui-spinner--variant': variant,

      }
    ]"
    :variant="(variant as ColorVariant)"
    :small="size === 'sm'"
  />
</template>

<style lang="sass">
$default-color: $gray-75

.ui-spinner

  /// Sizing
  &--sm#{&}--border
    border-width: 0.15rem

  &--lg#{&}--border
    width: 3rem
    height: 3rem
    border-width: 0.3rem

  /// Variant

  &:not(&--variant)
    color: $default-color

</style>

<script lang="ts">
import type { ColorVariant } from 'bootstrap-vue-next'
import { omit } from '~/utils/lib/core/prelude'
import type { SIZE, SPINNER_TYPE, VARIANT } from '~/utils/lib/layout/ui'
export default defineComponent({
  props: {
    variant: {
      type: String as PropType<VARIANT|undefined>,
      required: false,
      default: undefined
    },
    size: {
      type: String as PropType<SIZE>,
      required: false,
      default: 'md' satisfies SIZE
    },
    type: {
      type: String as PropType<SPINNER_TYPE>,
      required: false,
      default: 'border' satisfies SPINNER_TYPE
    },
  },
  computed: {
    // BSpinner has no `size` prop (only `small`); keep SIZE for our CSS.
    bSpinnerBind() {
      return {
        ...omit([ 'size' ], this.$props),
        ...this.$attrs,
      }
    },
  },
})
</script>
